import React, { useCallback } from 'react';
import { Button, Modal } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

/**
 * ResetButton Component
 * Displays a reset button with confirmation modal
 * Matches Figma design specifications
 *
 * @param {Object} props
 * @param {Function} props.onReset - Callback when reset is confirmed
 * @param {boolean} [props.disabled] - Whether the button is disabled
 */
const ResetButton = React.memo(({ onReset, disabled = false }) => {
  const { t } = useTranslation('sprayCalculator');

  const showConfirm = useCallback(() => {
    Modal.confirm({
      title: t('reset_confirm_title'),
      content: (
        <div style={{ whiteSpace: 'pre-line' }}>{t('reset_confirm_message')}</div>
      ),
      okText: t('reset_confirm_ok'),
      cancelText: t('reset_confirm_cancel'),
      okButtonProps: { danger: true },
      onOk: onReset,
    });
  }, [onReset, t]);

  return (
    <Button
      type="default"
      icon={<ReloadOutlined />}
      onClick={showConfirm}
      disabled={disabled}
      className="w-full sm:w-auto h-10 sm:h-[50px] px-3 sm:px-6 text-sm sm:text-base"
    >
      {t('reset_button')}
    </Button>
  );
});

ResetButton.displayName = 'ResetButton';

export default ResetButton;
